import { shouldUseFirebaseAuth } from '@util/authUtils';

import type { AuthInstanceInterface } from '../context/Auth/AuthContext';

let authInstancePromise: Promise<AuthInstanceInterface> | null = null;

/**
 * Get or create the auth instance singleton.
 * Lazy loads Firebase or MockAuth based on environment.
 */
export function getAuthInstance(): Promise<AuthInstanceInterface> {
  authInstancePromise ??= shouldUseFirebaseAuth()
    ? import('../context/Firebase/Firebase').then((m) => new m.Firebase())
    : import('../context/Auth/MockAuth').then((m) => new m.MockAuth());
  return authInstancePromise;
}
